"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.projection = void 0;
const Constants_1 = require("./Constants");
/**
 * fall function
 * @param t 0: near, -1: far
 * @returns 0 -> 1, ratio of y
 */
function fall(t) {
    return Math.pow(1.1, 50 * t);
}
/**
 * projection
 * @param trackpos 0: near, -1: far
 * @param laneOffset Lane center x or other
 */
function projection(trackpos, laneOffset) {
    const f = fall(trackpos);
    const r = ((Constants_1.FarLineZ - 1) * f + 1) / Constants_1.FarLineZ;
    return {
        x: Constants_1.CenterX + (laneOffset - Constants_1.CenterX) * r,
        y: Constants_1.LaneInfY + (Constants_1.LaneBottomY - Constants_1.LaneInfY) * r,
        scale: r,
    };
}
exports.projection = projection;
//# sourceMappingURL=Projection.js.map